import { create } from "zustand";
import { pricingStoreSlice } from "views/Components/Pricing/Main/pricingStoreSlice";
import { persist } from "zustand/middleware";
import { forecastStoreSlice } from "views/Components/Forecast/Main/forecastMainStoreSlice";
import { forecastHistoryStoreSlice } from "views/Components/Forecast/Admin/History/forecastHistoryStoreSlice";
import { forecastGeneralHistoryStoreSlice } from "views/Components/Forecast/Admin/General/forecastGeneralHistoryStoreSlice";
import { salesTrackingStoreSlice } from "views/Components/SalesTracking/Main/salesTrackingStoreSlice";
import { uiStoreSlice } from "views/Components/Shared/uiStoreSlice";
import { landedCostStoreSlice } from "views/Components/LandedCost/Store/landedCostStoreSlice";
import { productMasterStoreSlice } from "views/Components/Settings/ProductMaster/Store/productMasterStoreSlice";
import { CxStoreSlice } from "views/Components/Cx/Main/CxStoreSlice";
import { dealsToolStoreSlice } from "views/Components/Pricing/DealsTool/Main/DealsToolStoreSlice";
import { campaignManagerStoreSlice } from "views/Components/Martech/CampaignManager/CampaignManagerStore";
import { serviceOperationStoreSlice } from "views/Components/ServicesOperationComponent/Store/ServiceOperationStoreSlice";
import { launchSimulatorStoreSlice } from "views/Components/Pricing/LaunchSimulator/launchSimulatorStoreSlice";

export const useBoundStore = create(
  persist(
    (...a) => ({
      ...pricingStoreSlice(...a),
      ...forecastStoreSlice(...a),
      ...salesTrackingStoreSlice(...a),
      ...forecastHistoryStoreSlice(...a),
      ...forecastGeneralHistoryStoreSlice(...a),
      ...uiStoreSlice(...a),
      ...landedCostStoreSlice(...a),
      ...productMasterStoreSlice(...a),
      ...CxStoreSlice(...a),
      ...dealsToolStoreSlice(...a),
      ...campaignManagerStoreSlice(...a),
      ...serviceOperationStoreSlice(...a),
      ...launchSimulatorStoreSlice(...a),
    }),
    {
      name: "store",
      partialize: (state) => ({
        pricingSelectedOwners: state.pricingSelectedOwners,
        pricingSelectedDomains: state.pricingSelectedDomains,
        forecastSelectedOwner: state.forecastSelectedOwner,
        forecastSelectedCategory: state.forecastSelectedCategory,
        forecastSelectedMarketplace: state.forecastSelectedMarketplace,
        // Sales Tracking
        stStock: state.stStock,
        stSelectedOwners: state.stSelectedOwners,
        stSelectedDomains: state.stSelectedDomains,
        stSelectedKams: state.stSelectedKams,
        stLifeCycle: state.stLifeCycle,
        stSearch: state.stSearch,
        stSelectedBrand: state.stSelectedBrand,
        stSelectedMarketplace: state.stSelectedMarketplace,
        stSelectedCategoryPath: state.stSelectedCategoryPath,
        stShowedCellRows: state.stShowedCellRows,
        stShowedColumns: state.stShowedColumns,
        // Deals Tool: filtros y columnas visibles persisten POR PAÍS (snapshot
        // por countryId; useDealsToolCountryFilters carga/guarda al cambiar de
        // país o de filtros). dtRangeDate viaja como string ISO: sus consumidores
        // ya lo toleran (DealsTool usa new Date(), TimeRangeFilter pasa por dayjs()).
        dtFiltersByCountry: state.dtFiltersByCountry,
      }),
    },
  ),
);
